/**
 * @file
 * Reviews scripts.
 */

let $reviewReference = $('.views-comments-ref', context);

$reviewReference.once('review-reference').each(function() {
  let $this = $(this);

  // Equalize reviews items
  $this.find('.views-row').attr('data-equalizer-watch', 'equalize-reviews-ref');
  $this.attr({
    'data-equalizer': 'equalize-reviews-ref',
    'data-equalize-on': 'small'
  });
});
